import { ModuleWithProviders, NgModule } from '@angular/core';
import { NacoService } from './domains/services/naco.service';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { NACO_CONFIG, nacoFactory } from './factories/naco-factory';
import { Router } from '@angular/router';
import { Storage, UbudStorageModule } from '@ubud/storage';
import { NacoViewModule } from './views/module';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';

@NgModule({
    imports: [
        UbudStorageModule,
        NacoViewModule,
    ],
})
export class NacoModule {
    public static forRoot(config: { clientId: string, endpoint?: string }): ModuleWithProviders {
        return {
            ngModule: NacoModule,
            providers: [
                {
                    provide: NACO_CONFIG,
                    useValue: config,
                },
                {
                    provide: NacoService,
                    useFactory: nacoFactory,
                    deps: [NACO_CONFIG, Router, Storage, HttpClient, Location],
                },
                AuthenticatedGuard,
            ],
        };
    }
}
